export default __webpack_public_path__ + "static/media/AVISO_DE_PRIVACIDAD_EMPLEADOS.09f3bf94.pdf";